<template>
  <v-layout row wrap pa-5>
    <v-flex xs12 md12>
      <v-layout row wrap>
        <v-flex xs12 md12 SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            :time="time"
            @searchResource="searchResource" 
            @loadResource="reLoadResource"
            @create="()=>{newResource = {sections:[], splash:''}; dialog = true;}"
          />
        </v-flex>
        <v-flex xs12 md12 SearchC style="min-height:35px;">
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 md12 Filters>
          <!-- <Filters 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            :resource="resource"
            :time="time"
            @filterResource="filterResource"
          /> -->
        </v-flex>
        <v-flex xs12 md12 class="text-xs-center" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-flex>
        <v-flex xs12 md12 Details>
          <listPabelLandingPages
            :resource="resource"
            :resourceSettings="resourceSettings"
            @copyS="clipboardSuccessHandler"
            @copyF="clipboardErrorHandler"
            @editResource="editResource"
            :staticPages="true"
            :loading="loading"
            :resourceKeys="resourceKeys"
          />
        </v-flex>
        <v-flex xs12 md12 class="text-xs-center" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-flex>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          :resource="resource"
          @closeDialog="()=>{ dialog = false; newResource = {sections:[], splash:''}; }"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
          @getUpload="getUpload"
          @snackbarNotification="emitsnackbarNotification"
        />
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import catDialog from '@/components/catDialog'
import catsDialog from '@/components/catsDialog'
import listPabelLandingPages from '@/components/listPabelLandingPages'
import Filters from '@/components/Filters'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import {firebase, store, db, auth, storageRef } from '@/fb';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging, multiDialog, listPabelLandingPages, Filters, catDialog, catsDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      dialogCategory:false,
      dialogViewCategory:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        { name: 'slug', label: 'slug', type: 'text', fetched: 'slug', required: true, info:{en: 'unique slug'}},
        { name: 'title_ar', label: 'title_ar', type: 'text', fetched: 'title_ar', required: true, info:{en: 'AR title'}},
        { name: 'title_en', label: 'title_en', type: 'text', fetched: 'title_en', required: true, info:{en: 'EN title'}},
        { name: 'splash', label: 'splash', type: 'upload', fetched: 'splash', required: true, info:{en: 'splash image'}},
        { name: 'country_id', label: 'country', type: 'select', items:'countries', data:[], source:'db', info:{en: 'Country'}},
        
        { name: 'description_en', label: 'description_en', type: 'textarea', fetched: 'description_en', info:{en: 'web EN description'}},
        { name: 'description_ar', label: 'description_ar', type: 'textarea', fetched: 'description_ar', info:{en: 'web AR description'}},

        { name: 'active', label: 'Active', type: 'switch', fetched: 'active'},
        { name: 'navigation', label: 'Page show in Navigation', type: 'switch', fetched: 'navigation'},
        { name: 'footer', label: 'Page show in Footer', type: 'switch', fetched: 'footer'},

      ],
      categoryKeys:[
        { name: 'name', label: 'name', type: 'text', fetched: 'name', required: true, info:{en: 'internal name'}},
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        pagination:true,
        create:true,
      },
      newResource:{sections:[], splash:''},
      newCategory:{},
      editing:false,
      deleting:false,
      filter:'',
      time:0,
      page:1,
    }
  },
  
  methods: {
    emitsnackbarNotification(a, b){
      this.$emit('snackbarNotification', a, b)

    },
    getUpload(o){
      console.log(o)
      this.newResource[o.field] = o.value
    },
    editResource(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f.items]
            let maps = t.map(x=>{
              let t = x.name?x.name:null
              return{...x, text:t, [`${f.name}_id`]:x.id}
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async filterResource(filter){
      this.filter = filter
      this.page = 1
      await this.loadResource()
    },
    async reLoadResource(){
      this.search = null
      await this.loadResource()
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        let start = new Date().getTime()
        this.loading = true
        console.log(this.search)
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + `?page=${this.page}` + this.filter})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        let end = new Date().getTime()
        this.time = ((end - start) / 1000).toFixed(1)
        this.loading = false
        res()
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let start = new Date().getTime()
        this.page = n
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.filter})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        let end = new Date().getTime()
        this.time = ((end - start) / 1000).toFixed(1)
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(r)
        r.categories = r.categories_id
        console.log(JSON.stringify(r))
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {sections:[], splash:''}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {sections:[], splash:''}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        r.key = await db.ref(`productsCoreFakeKey`).push()
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {sections:[], splash:''}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    },
    async checkifSKUexists(sku){
      return new Promise(async (resolve, reject)=>{
        let a = await db.ref(`productsCore`).orderByChild('sku').equalTo(sku).once('value').then(x=>x.val())
        if(!a) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    async checkSkuIfNew(sku){
      return new Promise(async (resolve, reject)=>{
        if(this.creatingNewProduct) {
          if(await this.checkifSKUexists(sku)) {
            resolve(true)
          } else {
            this.$emit('snackbarNotification', `SKU ALREADY EXISTS`, 'error')
            resolve(false)
          }
        } else {
          resolve(true)
        }
      })
    },
    async postCustomResource(path, r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        this.newCategory = {}
        res()
      })
    },
    async updateCustomResource(path,r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        this.newCategory = {}
        res()
      })
    },
    async updateCategory(r){
      await this.updateCustomResource('/categories', r)
      this.dialogViewCategory = false
      this.dialogCategory = false
      await this.loadResource()

    },
    async postCategory(r){
      await this.postCustomResource('/categories', r)
      this.dialogViewCategory = false
      this.dialogCategory = false
      await this.loadResource()
    },
    viewCategories(){
      this.dialogViewCategory = true
    },
    editCategory(r){
      this.newCategory = r
      this.dialogCategory = true
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>